import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import delegate from '../views/delegate.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: process.env.VUE_APP_PUBLIC_PATH === '/staking-reward/' ? 'Home' : 'delegate',
    component: process.env.VUE_APP_PUBLIC_PATH === '/staking-reward/' ? Home : delegate
  },{
    path: '/validator',
    name: 'Home',
    component: Home
  }, {
    path: '/delegator',
    name: 'delegate',
    component: delegate
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
